import { RpcWorkItem, RpcWorkItemResult } from './rpc-work-item-model';

/**
 * Rpc work item sever side handler interface.
 */
export interface RpcWorkItemHandler {
    handler(data: RpcWorkItem): Promise<RpcWorkItemResult>;
}
